<template>
  <div>
    <div class="absolute inset-0 flex items-center justify-center">
      <swiper :pagination="{ clickable: true }" loop :autoplay="{ delay: 30000 }" class="w-full h-full">
        <swiper-slide class="disclaimer">
          <div class="absolute inset-0">
            <img src="images/SCENE_03_ROOFTOP_BUILDING_VIEW2_FINAL.jpg" srcset="images/SCENE_03_ROOFTOP_BUILDING_VIEW2_FINAL.jpg 1440w, images/SCENE_03_ROOFTOP_BUILDING_VIEW2_FINAL@2x.jpg 3440w" class="object-cover w-full h-full -mt-32 origin-top-left transform scale-125" alt="">
          </div>
        </swiper-slide>
        <swiper-slide class="flex disclaimer">
          <div v-bg-image="'images/escent-01.jpg'" class="flex-1 bg-cover" />
          <div v-bg-image="'images/bg-pattern.png'" class="flex-shrink-0 w-2/5 px-12 py-20 space-y-8 text-white bg-cover xl:px-16 xl:py-24 xl:w-1/3 2xl:w-1/4">
            <h1 class="mb-16 text-3xl font-bold uppercase xl:text-4xl xl:mb-32">
              A BETTER LIVING FOR ALL
            </h1>

            <p class="text-xl font-bold">
              อีกครั้ง กับชีวิตที่ดียิ่งกว่า...
            </p>

            <p class="">
              เอสเซ็นท์ โคราช คอนโดมิเนียม 33 ชั้น
              ติดศูนย์การค้า เซ็นทรัล โคราช
            </p>

            <p class="">
              ด้วยประสบการณ์ใหม่กับการอยู่อาศัยแนวสูง
              Facility ครบครันในทุกส่วนของโครงการ
              สร้างความสุข ให้ทุกความสะดวกสบาย
              มาอยู่ใกล้ ได้มากกว่าเคย
            </p>
          </div>
        </swiper-slide>

        <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
          <div class="relative row-span-full">
            <img src="images/shutterstock_1687521085.jpg" srcset="images/shutterstock_1687521085.jpg 1440w, images/shutterstock_1687521085@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full">
          </div>
          <div class="relative overflow-hidden">
            <img src="images/CPN ESCENT_KORAT_03SEMIOUTDOOR.jpg" alt="" class="absolute inset-0 object-cover w-full h-full">
            <!-- <img src="images/CPN ESCENT_KORAT_03SEMIOUTDOOR.jpg" srcset="images/CPN ESCENT_KORAT_03SEMIOUTDOOR.jpg 1440w, images/CPN ESCENT_KORAT_03SEMIOUTDOOR@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full origin-top-right transform scale-110"> -->
          </div>
          <div v-bg-image="'images/bg-pattern.png'" class="grid p-8 text-center text-white bg-white bg-cover xl:p-12 place-items-center">
            <div class="space-y-4 2xl:max-w-md 2xl:space-y-8 place-items-center">
              <h1 class="text-xl font-bold uppercase xl:text-3xl">
                on your way<br>
                en route to happiness
              </h1>
              <h2 class="text-lg font-bold xl:text-2xl">
                การเดินทางของความสุข เกิดขึ้นได้ที่นี่...
              </h2>
              <p class="text-xs xl:text-sm 2xl:text-base">
                ด้วยแนวคิด Journey to the North East
                จากประตูสู่ภาคอีสาน และบรรยากาศของการอยู่อาศัย
                การออกแบบที่ใส่ใจในรายละเอียด ในพื้นที่ใช้สอยร่วมกันที่ต่อเนื่องกัน
                เหมือนกับบ้านไทยในสมัยก่อน ให้คุณได้รู้สึกถึงความสุข และความอบอุ่นเหมือนบ้าน และยังสร้างความเชื่อมต่อกับทุกความสะดวก
                ให้เกิดขึ้นในที่เดียวอย่างครบครัน
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'ProjectConcept',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
